import { TextLink } from "nystem-components";

const FloatLink = (props) => <TextLink {...props} />;
export default FloatLink;
